module.exports = __webpack_public_path__ + "static/media/Gothorita_gaussian2.28e268f3.png";